import React from "react";
import { Breadcrumbs } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";

const BreadcrumbNav = ({ paths }) => {
  return (
    <div style={{ margin: "10px", marginTop: "90px" }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon />}
      >
        {paths.map((path, index) => (
          <Link
            key={index}
            to={path.url}
            style={{
              color: index === paths.length - 1 ? "red" : "black",
              textDecoration: "none",
            }}
          >
            {path.label}
          </Link>
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbNav;